const state = {
  companyDashboardSettings: {}
}
export default state
